import { HttpStatusCode } from "types/types";

export interface MediaGatewayClientErrorResponse {
  message?: string;
}

export type MediaGatewayClientErrorParams = {
  errorResponse: MediaGatewayClientErrorResponse[];
  status: HttpStatusCode;
  url?: string;
};

export class MediaGatewayClientError extends Error {
  url: string;
  status: HttpStatusCode;
  errorResponse: MediaGatewayClientErrorResponse[];

  constructor({ errorResponse, status, url }: MediaGatewayClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "MediaGatewayClientError";
    this.status = status;
    this.url = url;
    this.errorResponse = errorResponse;
  }
}
